function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 17"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 18"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 3",
  y: 3,
  width: 40,
  height: 40,
  rx: 20,
  fill: "#39FF14"
})), /*#__PURE__*/React.createElement("rect", {
  id: "svg-button",
  x: 2.5,
  y: 0.5,
  width: 39,
  height: 39,
  rx: 19.5,
  fill: "#C58FFF",
  stroke: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M25.3436 19.2532L25.1549 19.4261L25.3322 19.6107L30.2018 24.6801C30.2536 24.7419 30.2898 24.8137 30.3013 24.8736C30.3119 24.9286 30.3006 24.957 30.2797 24.9794L30.2739 24.9857L30.2685 24.9924C30.2481 25.0174 30.1941 25.0491 30.1009 25.0534C30.0101 25.0576 29.9421 25.0327 29.918 25.0166L24.4623 20.3598L24.2946 20.2167L24.1316 20.3652L21.6254 22.6489L19.1313 20.3656L18.9683 20.2164L18.8002 20.3598L13.3445 25.0166C13.3204 25.0327 13.2524 25.0576 13.1616 25.0534C13.0684 25.0491 13.0144 25.0174 12.994 24.9924L12.9886 24.9857L12.9828 24.9794C12.9619 24.957 12.9506 24.9286 12.9612 24.8736C12.9727 24.8137 13.0089 24.7419 13.0607 24.6801L17.9303 19.6107L18.1076 19.4261L17.9189 19.2532L12.8454 14.6045C12.7584 14.522 12.6837 14.4085 12.6633 14.2937C12.6457 14.195 12.662 14.0666 12.8143 13.9143C12.9677 13.7608 13.0964 13.7398 13.2108 13.7602C13.3462 13.7843 13.4985 13.8744 13.6623 14.0148L13.6622 14.0149L13.6679 14.0195L21.4679 20.3195L21.6249 20.4463L21.7819 20.3196L29.5944 14.0196L29.5945 14.0197L29.6002 14.0148C29.764 13.8744 29.9163 13.7843 30.0517 13.7602C30.1661 13.7398 30.2948 13.7608 30.4482 13.9143C30.6005 14.0666 30.6168 14.195 30.5992 14.2937C30.5788 14.4085 30.5041 14.522 30.4171 14.6045C30.4167 14.6049 30.4163 14.6053 30.4158 14.6057L25.3436 19.2532ZM32.5125 25.125V13.875C32.5125 12.6994 31.5631 11.75 30.3875 11.75H12.875C11.6994 11.75 10.75 12.6994 10.75 13.875V25.125C10.75 26.3006 11.6994 27.25 12.875 27.25H30.3875C31.5631 27.25 32.5125 26.3006 32.5125 25.125Z",
  fill: "#39FF14",
  stroke: "black",
  strokeWidth: 0.5
}));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6fabf7bd.svg";
export { ForwardRef as ReactComponent };